import React from "react";
import useHasPermission from "shared/hooks/useHasPermission";
import styled from "styled-components";
import TrailcottonLogo from "../../res/img/trailcotton.png";
import { pageSwitch as ConferenciaCampo } from "app/ConferenciaCampo/screens/Fazendas/pageSwitch";

function Home() {

  const hasPermissionRelatorioConfCampo = useHasPermission('relatorios.conferencia-do-campo');
  
  return (
    <>
      {
        hasPermissionRelatorioConfCampo
          ? <ConferenciaCampo />
          : (
            <Container>
              <Image aria-label="trailcotton-logo" src={TrailcottonLogo} />
            </Container>
          )
      }
    </>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  max-height: 100vh;
  width: 100%;
`;

const Image = styled.img`
  margin: auto;
  max-height: 100%;
`;

export default Home;
